var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImageIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none",
  viewBox: "0 0 28 28"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 28,
  height: 28,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M.5.5h27v27H.5z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#71717A",
  d: "M6.125 24.125q-.928 0-1.59-.66-.66-.662-.66-1.59V6.125q0-.928.66-1.59.662-.66 1.59-.66H16.25v2.25H6.125v15.75h15.75V11.75h2.25v10.125q0 .928-.66 1.59-.662.66-1.59.66zm13.5-13.5v-2.25h-2.25v-2.25h2.25v-2.25h2.25v2.25h2.25v2.25h-2.25v2.25zm-12.375 9h13.5L16.531 14l-3.375 4.5-2.531-3.375z"
}))));
export { SvgImageIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzI2OTlfMzAwMzUiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCI+CjxyZWN0IHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMjciIGhlaWdodD0iMjciIGZpbGw9IiNEOUQ5RDkiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzI2OTlfMzAwMzUpIj4KPHBhdGggZD0iTTYuMTI1IDI0LjEyNUM1LjUwNjI1IDI0LjEyNSA0Ljk3NjU2IDIzLjkwNDcgNC41MzU5NCAyMy40NjQxQzQuMDk1MzEgMjMuMDIzNCAzLjg3NSAyMi40OTM3IDMuODc1IDIxLjg3NVY2LjEyNUMzLjg3NSA1LjUwNjI1IDQuMDk1MzEgNC45NzY1NiA0LjUzNTk0IDQuNTM1OTRDNC45NzY1NiA0LjA5NTMxIDUuNTA2MjUgMy44NzUgNi4xMjUgMy44NzVIMTYuMjVWNi4xMjVINi4xMjVWMjEuODc1SDIxLjg3NVYxMS43NUgyNC4xMjVWMjEuODc1QzI0LjEyNSAyMi40OTM3IDIzLjkwNDcgMjMuMDIzNCAyMy40NjQxIDIzLjQ2NDFDMjMuMDIzNCAyMy45MDQ3IDIyLjQ5MzcgMjQuMTI1IDIxLjg3NSAyNC4xMjVINi4xMjVaTTE5LjYyNSAxMC42MjVWOC4zNzVIMTcuMzc1VjYuMTI1SDE5LjYyNVYzLjg3NUgyMS44NzVWNi4xMjVIMjQuMTI1VjguMzc1SDIxLjg3NVYxMC42MjVIMTkuNjI1Wk03LjI1IDE5LjYyNUgyMC43NUwxNi41MzEyIDE0TDEzLjE1NjIgMTguNUwxMC42MjUgMTUuMTI1TDcuMjUgMTkuNjI1WiIgZmlsbD0iIzcxNzE3QSIvPgo8L2c+Cjwvc3ZnPgo=";